





































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";
import { Const } from "@/const";
// TODO document2
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { SimpleTextLayer } from "@/model/document2/page/surface/design/layer/simpleTextLayer";
import { TextInfo } from "@/utilityModels/textInfo";
import { UnitHelper } from "@/helper/unitHelper";
import { MathHelper } from "@/helper/mathHelper";
import { UuidHelper } from "@/helper/uuidHelper";
import { StringHelper } from "@/helper/stringHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { FontManager } from "@/model/fontManager/fontManager";
import { DebugHelper } from "@/helper/debugHelper";
import { SimpleTextLayerHelper } from "@/helper/simpleTextLayerHelper";

import { Rectangle } from "@/utilityModels/rectangle";
import { FontFamily } from "../../../../../model/fontManager/fontFamily/fontFamily";
import { Vector2 } from "../../../../../utilityModels/vector2";

@Component({
  components: {}
})
export default class SimpleTextLayerDrawerA extends Vue {
  // プレースホルダー
  static readonly PLACEHOLDER_OPACITY = 0.5;
  // 文字の高さに対する下線の割合
  static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 22.0;
  // 文字の高さに対する下線までのスペース
  static readonly UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT = 4 / 22.0;

  @Prop() private layer!: SimpleTextLayer;
  @Prop() private scale!: number;
  @Prop() private offsetX!: number;
  @Prop() private offsetY!: number;
  @Prop() private isRendering!: boolean;
  @Prop() private isRenderingOnClient!: boolean;
  // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
  @Prop({ default: false }) private isInEditor!: boolean;

  private uuid = "";

  @Watch("layer.width")
  onWidthChanged(val: number, oldVal: number) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
  }

  @Watch("layer.height")
  onHeightChanged(val: number, oldVal: number) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
  }

  @Watch("layer.text")
  onTextChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.inEdit")
  onInEditChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.baseTextInfo.fontId")
  onFontIdChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.baseTextInfo.letterSpacing")
  onLetterSpacingChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.baseTextInfo.letterWidth")
  onLetterWidthChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.baseTextInfo.bold")
  onBoldChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.baseTextInfo.italic")
  onItalicChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.lineSpacing")
  onLineSpacingChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.autoSize")
  onAutoSizeChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.autoNewLine")
  onAutoNewLineChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
    this.updateEdittingTextIfNeeded();
  }

  @Watch("layer.prefix")
  onPrefixChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
  }

  @Watch("layer.suffix")
  onSuffixChanged(val, oldVal) {
    this.updateAutoFontSizeIfNeeded();
    this.updateAutoNewLineFontSizeIfNeeded();
  }

  private updateAutoFontSizeIfNeeded() {
    // テキスト編集中は更新しない
    if (this.layer.inEdit) return;
    // デザイン編集画面では編集面選択で更新しない
    if (!this.isInEditor && this.$route.path == "/DesignEditor") return;

    this.updateAutoFontSize();
  }

  private updateAutoFontSize() {
    if (this.layer.autoSize && !this.layer.autoNewLine) {
      var text = this.layerText;
      this.layer.autoFontSize = SimpleTextLayerHelper.calcAutoSize(
        text,
        this.$store.getters.fontManager,
        this.layer.baseTextInfo.fontId,
        this.layer.baseTextInfo.letterSpacing,
        this.layer.baseTextInfo.letterWidth,
        this.layer.lineSpacing,
        this.layer.width,
        this.layer.height,
        this.getFontWeight(),
        this.getFontStyle()
      );

      DebugHelper.trace(
        "updateAutoFontSizeIfNeeded : " + this.layer.autoFontSize
      );
    }
  }

  private updateAutoNewLineFontSizeIfNeeded() 
  {
    if (this.layer.autoNewLine)
    {
      if (this.layer.autoSize) 
      {
        // テキスト編集中は更新しない
        if (this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if (!this.isInEditor && this.$route.path == "/DesignEditor") return;
        this.updateAutoNewLineFontSize();
      }
      else
      {
        // テキスト編集中は更新しない
        if (this.layer.inEdit) return;
        // デザイン編集画面では編集面選択で更新しない
        if (!this.isInEditor && this.$route.path == "/DesignEditor") return;
        this.updateAutoNewLine();
      }
    }
  }

  private updateAutoNewLineFontSize()
  {
    let text = this.layerText;
    let result = SimpleTextLayerHelper.calcAutoLineSize(
      text,
      this.$store.getters.fontManager,
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.letterSpacing,
      this.layer.baseTextInfo.letterWidth,
      this.layer.lineSpacing,
      this.layer.width,
      this.layer.height,
      this.getFontWeight(),
      this.getFontStyle()
    );
    this.layer.autoFontSize = result.fontSize;
    this.layer.autoLineText = result.autoLineText;

    DebugHelper.trace(
      "updateAutoNewLineFontSizeIfNeeded : " + this.layer.autoFontSize
    );
    DebugHelper.trace(result.autoLineText);
  }

  private updateAutoNewLine()
  {
    let text = this.layerText;
    let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
      text,
      this.$store.getters.fontManager,
      this.layer.baseTextInfo.fontSize,
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.letterSpacing,
      this.layer.baseTextInfo.letterWidth,
      this.layer.lineSpacing,
      this.layer.width,
      this.layer.height,
      this.getFontWeight(),
      this.getFontStyle()
    );
    this.layer.autoLineText = lines;
      DebugHelper.trace(
      "getAutoLineTextWithFixedFontSize"
    );
    DebugHelper.trace(lines);
  }

  private updateEdittingTextIfNeeded()
  {
    if(this.layer.inEdit)
    {
      let lines = SimpleTextLayerHelper.getAutoLineTextWithFixedFontSize(
        this.layer.text,
        this.$store.getters.fontManager,
        this.layer.autoSize ? this.layer.autoFontSize : this.layer.baseTextInfo.fontSize,
        this.layer.baseTextInfo.fontId,
        this.layer.baseTextInfo.letterSpacing,
        this.layer.baseTextInfo.letterWidth,
        this.layer.lineSpacing,
        this.layer.width,
        this.layer.height,
        this.getFontWeight(),
        this.getFontStyle()
      );
      this.layer.edittingText = lines;
    }
  }

  mounted() {
    this.uuid = UuidHelper.getUuid();

    if (this.layer.autoFontSize <= 0) {
      // 強制的に自動サイズ更新
      this.updateAutoFontSize();
      this.updateAutoNewLineFontSize();
    } else {
      this.updateAutoFontSizeIfNeeded();
      this.updateAutoNewLineFontSizeIfNeeded();
    }
  }

  private get isVisibleBySystem() {
    // エディット対象以外かつ、文字列が空なら表示しない
    return this.isInEditor || this.layer.text != "";
  }

  private getFontSizeMm() {
    var fontSize = this.layer.autoSize
      ? this.layer.autoFontSize
      : this.layer.baseTextInfo.fontSize;
    return UnitHelper.convert(fontSize, "pt", "mm");
  }

  private get x() {
    if (this.layer.horizontalAlignment == 1) {
      return this.layer.x + this.layer.width / 2;
    } else if (this.layer.horizontalAlignment == 2) {
      return this.layer.x + this.layer.width;
    } else {
      return this.layer.x;
    }
  }

  private get y() {
    return this.layer.y;
  }

  private get opacity() {
    return this.layer.text == ""
      ? SimpleTextLayerDrawerA.PLACEHOLDER_OPACITY
      : this.layer.opacity / 100;
  }

  private get layerText() {
    var text = "";
    if (this.layer.inEdit) {
      // テキスト編集中はプレースホルダ、語頭語尾を表示しない
      text = this.layer.text;
    } else if (!this.isInEditor && this.isRendering) {
      // レンダリング時とエディタ以外はプレースホルダを表示しない
      text =
        this.layer.text == ""
          ? ""
          : this.layer.prefix + this.layer.text + this.layer.suffix;
      // 全角対応
      if (this.layer.baseTextInfo.isEmQuad)
        text = StringHelper.toEmQuadString(text);
    } else {
      text =
        this.layer.text == ""
          ? "文字を入力"
          : this.layer.prefix + this.layer.text + this.layer.suffix;
      // 全角対応
      if (this.layer.baseTextInfo.isEmQuad)
        text = StringHelper.toEmQuadString(text);
    }

    return text;
  }

  private get lineInfoArray() {
    var array: Array<{
      x: number;
      y: number;
      width: number;
      height: number;
      dx: string;
      text: string;
    }> = [];
    // 改行コードで分離
    var renderingText =
      this.layer.autoNewLine && this.layer.autoLineText.length > 0
        ? this.layer.autoLineText
        : this.layerText;
    if (this.isInEditor && this.layer.inEdit) renderingText = this.layer.edittingText;
    var lines = renderingText.split("\n");
    // 字間
    var letterSpacing = UnitHelper.convert(
      this.layer.baseTextInfo.letterSpacing,
      "pt",
      "mm"
    );
    letterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;
    // 各行について情報を生成する
    // 基準位置X
    var basex = this.layer.x;
    if (this.layer.horizontalAlignment == 1) {
      basex +=
        ((this.layer.width / 2) * 100) / this.layer.baseTextInfo.letterWidth;
    } else if (this.layer.horizontalAlignment == 2) {
      basex += (this.layer.width * 100) / this.layer.baseTextInfo.letterWidth;
    }
    // 基準位置Y
    var basey = this.layer.y;
    var curx = basex;
    var cury = basey;
    var fontSize = this.getFontSizeMm();
    var fontManager: FontManager = this.$store.getters.fontManager;
    var fontFamily = fontManager.getSimpleTextFontFamilyName(
      this.layer.baseTextInfo.fontId,
      false
    );
    for (var i = 0; i < lines.length; ++i) {
      var line = lines[i];
      // 行サイズ計測
      var lineSize = StringHelper.calcTextSizeOnSVGPt(
        line.length == 0 ? " " : line,
        fontSize,
        fontFamily
      );
      if (line.length == 0) lineSize.width = 0;
      // この行の描画位置を行の高さ分下にずらす
      cury += lineSize.height;

      // 字間情報を設定する
      if (this.layer.horizontalAlignment == 3 && line.length > 0) {
        // 均等揃え
        letterSpacing = (this.layer.width - lineSize.width) / (line.length - 1);
        letterSpacing *= 100 / this.layer.baseTextInfo.letterWidth;
      }

      var dx = "";
      for (var c = 0; c < line.length; ++c) {
        if (dx.length > 0) dx += " ";
        if (c == 0) dx += "0";
        else dx += letterSpacing;
      }

      var totalLetterSpacing =
        line.length > 0 ? letterSpacing * (line.length - 1) : 0;

      array.push({
        x: curx,
        y: cury,
        dx: dx,
        width: lineSize.width + totalLetterSpacing,
        height: lineSize.height,
        text: line
      });

      // 改行する
      curx = basex;
      // 最終行以外は行間を開ける
      if (i < lines.length - 1)
        cury += (lineSize.height * (this.layer.lineSpacing - 100)) / 100;
    }

    if (this.layer.verticalAlignment > 0) {
      // 縦方向揃え処理
      var dy = 0;
      if (this.layer.verticalAlignment == 1) {
        // 中央揃え
        dy = (this.layer.y + this.layer.height - cury) / 2;
      } else if (this.layer.verticalAlignment == 2) {
        // 下揃え
        dy = this.layer.y + this.layer.height - cury;
      }
      for (var i = 0; i < array.length; ++i) {
        array[i].y += dy;
      }
    }

    return array;
  }

  private calcUnderLineRectFromLineInfo(info: {
    x: number;
    y: number;
    width: number;
    height: number;
    dx: string;
    text: string;
  }) {
    var x = info.x;
    var y =
      info.y +
      this.getFontSizeMm() *
        SimpleTextLayerDrawerA.UNDERLINE_SPACING_FROM_CHARACTER_HEIGHT;
    var width = info.width;
    var height = this.underlineHeight;
    if (this.layer.horizontalAlignment == 1) {
      x -= info.width / 2;
    } else if (this.layer.horizontalAlignment == 2) {
      x -= info.width;
    }

    return { x: x, y: y, width: width, height: height };
  }

  private get textAnchor() {
    if (this.layer.horizontalAlignment == 1) {
      return "middle";
    } else if (this.layer.horizontalAlignment == 2) {
      return "end";
    } else {
      return "left";
    }
  }

  private get fontSize() {
    return this.getFontSizeMm() + "px";
  }

  private getFontFamily(): string {
    var fontManager: FontManager = this.$store.getters.fontManager;
    var family = fontManager.getSimpleTextFontFamilyName(
      this.layer.baseTextInfo.fontId,
      this.isRendering && !this.isRenderingOnClient,
      this.isRenderingOnClient
    );
    return family;
  }

  private get fontStyle() {
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: this.layer.baseTextInfo.textColor.hex,
      "white-space": "pre"
    };

    return style;
  }

  private get shadowFontStyle() {
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: this.layer.baseTextInfo.shadowColor.hex,
      "white-space": "pre"
    };

    return style;
  }

  private shiftShadow(x: number, y: number) {
    var distance =
      (this.getFontSizeMm() * 2 * this.layer.baseTextInfo.shadowDistance) / 100;
    var radian = (this.layer.baseTextInfo.shadowRotate * Math.PI) / 180;
    var xDistance = distance * Math.cos(radian);
    var yDistance = distance * Math.sin(radian);
    return new Vector2(x + xDistance, y + yDistance);
  }

  private get shadowBlueId() {
    return "shadow_blur_" + this.uuid;
  }

  private get shadowDiviation() {
    return (0.8 * this.layer.baseTextInfo.shadowBlur) / 100;
  }

  private get shadowOpacity() {
    return this.layer.baseTextInfo.shadowIntensity / 100;
  }

  private get outlineFontStyle() {
    var outlineThickness =
      (this.getFontSizeMm() * this.layer.baseTextInfo.outlineThickness) / 750;
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-weight": this.getFontWeight(),
      "font-style": this.getFontStyle(),
      fill: "none",
      stroke: this.layer.baseTextInfo.outlineColor.hex,
      "stroke-width": this.alternativeOutlineThickness() + outlineThickness,
      "stroke-linejoin": "round",
      "white-space": "pre"
    };

    return style;
  }

  private get outlineOpacity() {
    return this.layer.baseTextInfo.outlineIntensity / 100;
  }

  private get isVisibleAlternativeOutline() {
    return this.layer.baseTextInfo.bold && FontManager.UseAlternativeOutlineToBold(this.layer.baseTextInfo.fontId);
  }

  private alternativeOutlineThickness() {
    return this.isVisibleAlternativeOutline ? this.getFontSizeMm() * 24 / 750 : 0;
  }

  private get alternativeOutlineStyle() {
    var style = {
      "font-family": this.getFontFamily(),
      "font-size": this.getFontSizeMm() + "px",
      "font-style": this.getFontStyle(),
      fill: "none",
      stroke: this.layer.baseTextInfo.textColor.hex,
      "stroke-width": this.alternativeOutlineThickness(),
      "stroke-linejoin": "round",
      "white-space": "pre"
    };

    return style;
  }

  private getFontWeight(): string {
    return SimpleTextLayerHelper.getFontWeight(
      this.layer.baseTextInfo.fontId,
      this.layer.baseTextInfo.bold,
      this.$store.getters.fontManager,
      this.isRendering,
      this.isRenderingOnClient
    );
  }

  private getFontStyle(): string {
    return this.layer.baseTextInfo.italic ? "italic" : "normal";
  }

  private get transform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
    // スケール
    transform += "scale(" + this.scale + " " + this.scale + "),";
    transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    // 文字横幅を適用する
    transform +=
      "scale(" + this.layer.baseTextInfo.letterWidth / 100 + " " + 1 + "),";
    transform += "translate(" + -this.layer.x + " " + -this.layer.y + ")";

    return transform;
  }

  private get caretTransform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";

    transform +=
      "translate(" +
      this.layer.x * this.scale +
      " " +
      this.layer.y * this.scale +
      "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    transform +=
      "translate(" +
      -this.layer.x * this.scale +
      " " +
      -this.layer.y * this.scale +
      ")";

    return transform;
  }

  private get rectTransform() {
    var transform = "";

    // オフセット
    transform += "translate(" + this.offsetX + " " + this.offsetY + "),";
    // スケール
    transform += "scale(" + this.scale + " " + this.scale + "),";
    transform += "translate(" + this.layer.x + " " + this.layer.y + "),";
    // 回転を適用する
    transform += "rotate(" + this.layer.rotate + "),";
    // 幅・高さによる反転を適用する
    transform +=
      "scale(" +
      (this.layer.width < 0 ? -1 : 1) +
      " " +
      (this.layer.height < 0 ? -1 : 1) +
      "),";
    transform += "translate(" + -this.layer.x + " " + -this.layer.y + ")";

    return transform;
  }

  // キャレットを表示するか
  private get charetVisible() {
    // レンダリング中表示しない
    if (this.isRendering) {
      return false;
    }
    // エディット対象でなければ表示しない
    if (!this.isInEditor) {
      return false;
    }

    return (
      this.layer.inEdit && this.layer.startPosition == this.layer.endPosition
    );
  }
  private get caretPosition() {
    // const p0 = performance.now();
    var rectArray = SimpleTextLayerHelper.getRenderingTextRectArray(
      this.layer,
      this.$store.getters.fontManager,
      this.layer.startPosition,
      this.layer.startPosition + 1
    );
    if (rectArray.length == 0) {
      // console.warn('a', performance.now() - p0);
      return { x1: 0, y1: 0, x2: 0, y2: 0 };
    }
    var rect = rectArray[0].rect;
    var charetPos = {
      x1: rect.x,
      y1: rect.y,
      x2: rect.x,
      y2: rect.y + rect.height
    };
    if (Math.abs(charetPos.x1 - this.layer.x) < 0.2) {
      charetPos.x1 = charetPos.x2 = this.layer.x + 0.2;
    }
    if (Math.abs(charetPos.x1 - (this.layer.x + this.layer.width)) < 0.2) {
      charetPos.x1 = charetPos.x2 = this.layer.x + this.layer.width - 0.2;
    }
    // console.warn('a', performance.now() - p0);
    return {
      x1: charetPos.x1 * this.scale,
      y1: charetPos.y1 * this.scale,
      x2: charetPos.x2 * this.scale,
      y2: charetPos.y2 * this.scale
    };
  }

  // 選択を表示するか
  private get selectionVisible() {
    // レンダリング中表示しない
    if (this.isRendering) {
      return false;
    }
    // エディット対象でなければ表示しない
    if (!this.isInEditor) {
      return false;
    }

    return (
      this.layer.inEdit && this.layer.startPosition != this.layer.endPosition
    );
  }

  // 選択領域
  private get selectionRectArray() {
    var start = Math.min(this.layer.startPosition, this.layer.endPosition);
    var end = Math.max(this.layer.startPosition, this.layer.endPosition);
    return SimpleTextLayerHelper.getRenderingTextRectArray(
      this.layer,
      this.$store.getters.fontManager,
      start,
      end
    );
  }

  private get underlineHeight() {
    return (
      this.getFontSizeMm() *
      SimpleTextLayerDrawerA.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT
    );
  }
}
